import React from 'react';
import { graphql } from 'gatsby';

import Cal, { getCalApi } from '@calcom/embed-react';
import { useEffect } from 'react';

import SanityPortableText from '../SanityPortableText';

import PancakeIntro from '../PancakeIntro';
import Pancake from './Pancake';
import Container from '../Container';

import Card from '../Card';
import classnames from 'classnames';

import './Calcom.scss';

const Calcom = (props) => {
  const {
    title,
    text,
    formURL = 'introduction',
    blocks,
    theme,
    children,
    className,
  } = props;
  const containerSize = blocks === null ? 'Small' : null;

  useEffect(() => {
    (async function () {
      const cal = await getCalApi({ namespace: formURL });
      cal('ui', {
        theme: 'light',
        hideEventTypeDetails: true,
        layout: 'month_view',
      });
    })();
  }, []);

  return (
    <Pancake className={classnames('CalcomPancake', className)} theme={theme}>
      <Container size={containerSize}>
        {(title || text) && (
          <PancakeIntro title={title} text={text} textAlign="Left" />
        )}
        <div className="CalcomPancakeGrid">
          <div>
            {children}
            {blocks?.length > 0 && (
              <div className="CalcomPancakeContent">
                <SanityPortableText blocks={blocks} />
              </div>
            )}
          </div>
          <Card className="CalcomPancakeCard">
            <Cal
              namespace={formURL}
              calLink={`team/okteto/${formURL}`}
              style={{ width: '100%', height: '100%', overflow: 'scroll' }}
              config={{ layout: 'month_view', theme: 'light' }}
            />
          </Card>
        </div>
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeCalcom on SanityCalcom {
    _key
    _type
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
    _rawPancakeText
    formURL
    theme
  }
`;

export default Calcom;
